<script setup lang="ts">
const directUrl = 'https://unireel.onelink.me/lKAP/5j29ay15'
document.title = 'UniReelをダウンロード，ショットドラマを楽しみ'
</script>

<template>
  <div class="main">
    <img src="@/assets/icon-redeem-logo.png" class="logo" alt="logo">
    <div class="content">
      <div class="title" :href="directUrl">
        <img src="@/assets/icon-redeem-left.png" alt="left">
        <span>引換方法</span>
        <img src="@/assets/icon-redeem-right.png" alt="right">
      </div>
      <div class="widget">
        <span>UniReelをダウンロード</span>
        <a :href="directUrl" class="button">ダウンロード</a>
      </div>
      <div class="guide">
        <img src="@/assets/icon-redeem-content.png" alt="content">
      </div>
    </div>
    <div class="describtion">
      <div class="detail">
        説明
      </div>
      <div class="tip">
        <div>1．同一の引換コードの使用回数は1回までです。</div>
        <div>2．引換コードには有効期限があります。有効期限が過ぎたものは利用できません。</div>
        <div>3．引換コードの使用人数には制限があります。制限に達すると、引き換えはできなくなります。</div>
      </div>
    </div>
    <div class="bottom">
      <a :href="directUrl" class="button">
        <span>UniReelをダウンロード</span>
        <span>ショートドラマを楽しもう</span>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  width: 100vw;
  max-width: var(--var-max-body-width, 750px);
  min-height: 100vh;
  background-color: #000;
  background-image: url('@/assets/icon-redeem-bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  color: #fff;
  position: relative;
  padding-top: 30px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 69px;
  box-sizing: border-box;
}
.logo {
  width: 148px;
}
.content {
  width: 100%;
  background-color: #181818;
  margin-top: 27px;
  padding-top: 12px;
  padding-bottom: 20px;
  border-radius: 13px;

}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  span {
    margin-left: 7px;
    margin-right: 7px;
    font-size: 15px;
  }
  img {
    width: 34px;
  }
}

.widget {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  align-items: center;
  span {
    font-size: 14px;
    line-height: 20px;
    width: 159px;
    margin-right: 32px;
  }
  .button {
    width: 123px;
    height: 36px;
    background-color: #DF005E;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
  }
}
.guide {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  img {
    width: 100%;
  }
}
.describtion {
  color: #fff;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 41px;
  margin-top: 20px;
  .detail {
    font-weight: bold;
  }
  .tip {
    color: rgb(255, 255, 255,0.7);
  }
}
.bottom {
  width: 100%;
  background-color: #181818;
  position: fixed;
  bottom: 0px;
  left: 0;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 16px;
  padding-bottom: 16px;
  .button {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    line-height: 17px;
    width: 100%;
    height: 50px;
    border-radius: 25px;
    background-color: #DF005E;
    justify-content: center;
    span:first-child {
      font-size: 17px;
      font-weight: bold;
    }
  }

}
</style>
